import PropTypes from 'prop-types';
import React from 'react';
import { formValues } from 'redux-form';
import { withProps } from 'recompose';
import computeInvestment from 'common/model/simulation/dismemberedScpi/computeInvestment';
import { formatAmount } from 'common/utils/format';
import { DisabledField } from 'components/form/field';
import { flowRight } from 'lodash';

const InvestmentInner = ({ amount, namePrefix = 'data' }) => (
    <DisabledField
        name={`${namePrefix}.investmentAmount`}
        title="Montant estimé de l'investissement"
        value={formatAmount(amount, true)}
    />
);

InvestmentInner.propTypes = {
    amount: PropTypes.number.isRequired,
    namePrefix: PropTypes.string,
};

const Investment = flowRight([
    formValues(({ namePrefix = 'data' }) => ({
        products: `${namePrefix}.products`, duration: `${namePrefix}.duration` })),
    withProps(({ products, duration, namePrefix = 'data' }) => ({
        amount: computeInvestment(duration)(products),
        namePrefix,
    })),
])(InvestmentInner);

export default Investment;
